import styled, { css } from 'styled-components';

export const DropdownOptionWrapper = styled.div<{
  isOpen: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: start;

  padding-left: 16px;
  width: 100%;
  height: 40px;
  font-size: 16px;
  font-weight: 400;
  line-height: 25px;

  cursor: pointer;
  user-select: none;
  background: ${({ theme }) => theme.COLOR.WHITE};
  & > p {
    ${({ theme }) => theme.FONT.B2};
    font-weight: 400;
    color: ${({ theme }) => theme.COLOR.GREY_01};
  }

  ${({ isOpen }) =>
    isOpen &&
    css`
      &:hover {
        background: rgba(126, 126, 126, 0.14);
      }
    `}
`;

export const DropdownOptionText = styled.p<{ isUserSelected?: boolean }>`
  color: ${({ theme, isUserSelected }) =>
    !isUserSelected && theme.COLOR.GREY_01};
`;

export const ArrowIconWrapper = styled.div`
  position: absolute;
  height: fit-content;
  top: 2px;
  right: 9px;
  padding: 10px;
  cursor: pointer;
`;

export const ArrowIcon = styled.img`
  width: 10px;
  height: 14px;

  ${({ theme }) => theme.SVG_FILTER.GREY_01};
`;

export const Wrapper = styled.div<{
  isOpen: boolean;
  isKST?: boolean;
  isMobile?: boolean;
  width?: string;
  direction: 'top' | 'bottom';
  topPosition?: number;
  borderColor?: string;
}>`
  position: absolute;
  ${({ direction, topPosition }) => {
    if (direction === 'bottom') {
      return `top: ${topPosition ? topPosition : 33}px;`;
    } else if (direction === 'top') {
      return 'bottom: 38px;';
    }
  }}
  left: 0;

  border: 1px solid
    ${({ theme, borderColor }) =>
      borderColor ? borderColor : theme.COLOR.GREY_05};
  border-radius: 5px;
  background-color: ${({ theme }) => theme.COLOR.WHITE};

  width: ${({ width }) => width || '100%'};
  max-height: 174px;
  overflow-y: ${({ isOpen }) => (isOpen ? 'scroll' : 'hidden')};
  transition: height 0.25s ease-in;
  z-index: ${({ isOpen }) => isOpen && '10'};
`;
